import { render } from "./Roles.vue?vue&type=template&id=bd68651a&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=bd68651a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd68651a"]])

export default __exports__